import { ResolutionOverlays } from '@doer/frontend-components/creativity-editor';
import { ESPN_HEROS_BASE_URL } from './urls';

export const ESPN_HEROS_OVERLAYS: Record<string, ResolutionOverlays> = {
  '1920x2400': {
    safeZones: `${ESPN_HEROS_BASE_URL}/zones/safe/1920x2400.png`,
    faceGuides: `${ESPN_HEROS_BASE_URL}/zones/face-guides/1920x2400.png`
  },
  '2000x2818': {
    safeZones: `${ESPN_HEROS_BASE_URL}/zones/safe/2000x2818.png`,
    faceGuides: `${ESPN_HEROS_BASE_URL}/zones/face-guides/2000x2818.png`
  },
  '3840x982': {
    safeZones: `${ESPN_HEROS_BASE_URL}/zones/safe/3840x982.png`,
    faceGuides: `${ESPN_HEROS_BASE_URL}/zones/face-guides/3840x982.png`
  },
  '3840x1280': {
    safeZones: `${ESPN_HEROS_BASE_URL}/zones/safe/3840x1280.png`,
    faceGuides: `${ESPN_HEROS_BASE_URL}/zones/face-guides/3840x1280.png`
  },
  '3840x2160': {
    safeZones: `${ESPN_HEROS_BASE_URL}/zones/safe/3840x2160.png`,
    faceGuides: `${ESPN_HEROS_BASE_URL}/zones/face-guides/3840x2160.png`
  }
};
